@if (!summary) {
  <mat-form-field class="w-100"
    >
    @if (!hideLabels) {
      <mat-label [innerHtml]="question.editLabel | localized"></mat-label>
    }
    <input type="number"
      min="0"
      matInput
      [formControl]="control"
      [value]="control?.value"
      [required]="question.isRequired"
      [id]="question.questionNumber">
      @if (!control.valid) {
        <mat-error>
          {{'form.validation.required' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }

  @if (summary) {
    <p
      class="summary">
      @if (!hideLabels) {
        <label  [innerHtml]="question.summaryLabel | localized"> : </label>
      }
      @if (control.value === null) {
        <span
        class="notFilled">N/A</span>
      } @else {
        <span>{{ control.value }}</span>
      }
    </p>
  }